import { ActionType, OPEN_DRAWER, CLOSE_DRAWER } from '../actions/drawer'

export interface DrawerState {
    isOpen: boolean
}

const initialState: DrawerState = {
    isOpen: false
}

export function drawerReduer(state: DrawerState = initialState, action: ActionType) {
    switch (action.type) {
        case OPEN_DRAWER: {
            return {
                ...state,
                isOpen: true
            }
        }
        case CLOSE_DRAWER: {
            return {
                ...state,
                isOpen: false
            }
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/drawer.ts